<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Sendgrid Domains</span> </h4>
                    <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" style="min-height: 500px;" :class="{'loading-mask': loading}">
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh domain list</button>
                    <button :disabled="page >= pages" @click="nextPage" class="btn btn-primary pull-right" style="margin: 10px">Next page >></button>
                    <button :disabled="true" class="btn btn-primary pull-right" style="margin: 10px">Page: {{(offset/limit)+1}}</button>
                    <button :disabled="offset <= 0" @click="prevPage" class="btn btn-primary pull-right" style="margin: 10px">
                        << Previous page</button> <div class="form-check form-check-inline">
                            <multiselect v-model="sendgridId" tag-placeholder="" placeholder="Choose mailer account" label="name" track-by="_id" :options="sendgrid_acc" :multiple="false"></multiselect>
                </div>
                <table class="table table-striped table-xs" style="min-height: 100px">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Domain id</th>
                            <th>Domain</th>
                            <th>Domain found</th>
                            <th>Active / pending campaign found</th>
                            <th>Subdomain</th>
                            <th>Username</th>
                            <th>Valid</th>
                            <th>Last validation attemp</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="r,k in rows">
                            <td style="width:10px">{{k+1}}</td>
                            <td>{{r.id}}</td>
                            <td>{{r.domain}}</td>
                            <td>
                                <span v-tooltip="'Whether the domain is listed on Domain tab'" class="badge" :class="{'bg-slate': r.db._id, 'bg-danger': !r.db._id}">{{r.db._id ? 'Domain listed' : 'Domain not listed'}}</span>
                            </td>
                            <td>
                                <span v-tooltip="'If there is any campaign with status paused, completed, scheduled'" class="badge" :class="{'bg-slate': activeCampaign(r.cmpg), 'bg-danger': !activeCampaign(r.cmpg)}">{{activeCampaign(r.cmpg) ? 'Active campaigns' : 'No active campaigns'}}</span>
                            </td>
                            <td>{{r.subdomain}}</td>
                            <td>{{r.username}}</td>
                            <td>
                                <span class="badge" :class="{'bg-slate': r.valid, 'bg-danger': !r.valid}">{{r.valid ? 'Valid' : 'Not valid'}}</span>
                            </td>
                            <td>
                                <template v-if="r.last_validation_attempt_at">{{r.last_validation_attempt_at*1000|formatDate}}</template>
                            </td>
                            <td>
                                        <button v-if="!activeCampaign(r.cmpg)" @click="deregisterSendgrid($event, r.id, r.db._id)" class="btn btn-danger">
                                            Deregister Sendgrid
                                        </button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <!-- /content area -->
    <!-- /content area -->
    </div>
</template>
<script>
import moment from 'moment'
import EventBus from '@/event_bus'
export default {
    components: {},
    data() {
        return {
            sendgrid_acc: [],
            sendgridId: null,
            rows: [],
            loading: true,
            adding: false,
            limit: 200,
            offset: 0,
            count: 0
        }
    },
    watch: {
        sendgridId() {
            this.load()
        }
    },
    computed: {
        pages() {
            return Math.ceil(this.count / this.limit)
        },
        page() {
            return (this.offset / this.limit) + 1
        },
    },
    filter: {
        
    },
    methods: {
        activeCampaign: (campaigns)=>{
            return campaigns.filter(c => ['paused', 'completed', 'scheduled'].indexOf(c.status))>=0
        },
        prevPage() {
            this.offset -= 200
            this.load()
        },
        nextPage() {
            this.offset += 200
            this.load()

        },
        deregisterSendgrid(_, domainId, dbDomainId) {
            this.$confirm().then(() => {
                this.loading = true
                this.$api.postReq('deregister/sendgrid_by_id/' + domainId+'?sendgridAccountId='+this.sendgridId._id+'&dbDomainId='+dbDomainId).then(res => {
                    this.$notify.addSuccess("Domain deregistered")
                    this.loading = false
                    this.load()
                })
            })
        },

        load(showloader, changePage, refreshProfile) {
            if(!this.sendgridId){
                return
            }
            this.loading = true
            this.$api.getReq(`domain/list/${this.sendgridId._id}?limit=${this.limit}&offset=${this.offset}`).then(res => {
                this.rows = res.body.data
                this.count = res.body.count
                this.loading = false
            })
        }
    },
    destroyed() {},
    mounted() {
        this.$api.getReq('accounts/sendgrid').then(res => {
            this.sendgrid_acc = res.body.data
        })
        this.loading = false
        //this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/AuthenticatedDomains.vue